'use client';
import { jsx as _jsx } from "react/jsx-runtime";
import { useLayoutEffect } from 'react';
import { hasMessageContent, useFieldContext } from './FieldContext';
import styles from './Field.module.css';
/**
 * Compound member of <Field>. Renders an error message with role="alert" and
 * aria-live="polite" so async error appearance is announced by assistive
 * technology. While it has content it is linked into the control's
 * aria-describedby chain and marks the control aria-invalid.
 *
 * The region renders even when empty, so an error that arrives later is a
 * change inside an already-registered live region.
 */
export function FieldError({ children }) {
    const ctx = useFieldContext();
    const register = ctx?.registerMessage;
    const present = hasMessageContent(children);
    useLayoutEffect(() => (present ? register?.('error') : undefined), [register, present]);
    return (_jsx("div", { id: ctx?.ids.error, role: "alert", "aria-live": "polite", className: styles.error, children: children }));
}
//# sourceMappingURL=FieldError.js.map